import axiosAuthInstance from '../utils/getSubdomain';

export const getNotifications = () => {
  return axiosAuthInstance.get('/notifications/');
};

export const markNotificationRead = (notificationId: string) => {
  return axiosAuthInstance.post(
    `/notifications/${notificationId}/mark-as-read`,
    {}
  );
};
